(() => {
  const roots = document.querySelectorAll('[data-wpm-vehicle-finder]');
  if (!roots.length) return;

  const uniqueSorted = (values) =>
    Array.from(new Set(values.filter(Boolean))).sort((a, b) =>
      String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' })
    );

  const yearsFrom = (item) => {
    const raw = String(item && item.year ? item.year : '').trim();
    const match = raw.match(/^(\d{4})(?:\s*[-–]\s*(\d{4}))?$/);
    if (!match) return raw ? [raw] : [];
    const start = Number(match[1]);
    const end = Number(match[2] || match[1]);
    if (!Number.isFinite(start) || !Number.isFinite(end) || end < start) {
      return [String(start)];
    }
    const years = [];
    for (let year = start; year <= end; year += 1) years.push(String(year));
    return years;
  };

  const itemMatchesYear = (item, year) => {
    if (!year) return true;
    return yearsFrom(item).includes(year);
  };

  const fillSelect = (select, values, placeholder) => {
    const current = select.value;
    select.innerHTML = '';
    const empty = document.createElement('option');
    empty.value = '';
    empty.textContent = placeholder;
    select.appendChild(empty);
    values.forEach((value) => {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      select.appendChild(option);
    });
    if (values.includes(current)) select.value = current;
    else select.value = '';
  };

  roots.forEach((root) => {
    const dataEl = root.querySelector('[data-wpm-vehicle-data]');
    const form = root.querySelector('[data-wpm-vehicle-form]');
    const yearSelect = root.querySelector('[data-wpm-vehicle-year]');
    const makeSelect = root.querySelector('[data-wpm-vehicle-make]');
    const modelSelect = root.querySelector('[data-wpm-vehicle-model]');
    const submit = root.querySelector('[data-wpm-vehicle-submit]');
    const error = root.querySelector('[data-wpm-vehicle-error]');
    if (!dataEl || !form || !yearSelect || !makeSelect || !modelSelect || !submit) return;

    let applications = [];
    try {
      applications = JSON.parse(dataEl.textContent || '[]');
    } catch (_) {
      applications = [];
    }

    const showError = (message) => {
      if (!error) return;
      error.textContent = message || '';
      error.classList.toggle('is-visible', Boolean(message));
    };

    const filtered = () => {
      const year = yearSelect.value;
      const make = makeSelect.value;
      return applications.filter((item) => {
        if (!itemMatchesYear(item, year)) return false;
        if (make && item.make !== make) return false;
        return true;
      });
    };

    const refresh = () => {
      const year = yearSelect.value;
      const make = makeSelect.value;
      const years = uniqueSorted(applications.flatMap(yearsFrom));
      fillSelect(yearSelect, years, yearSelect.dataset.placeholder || 'Year');

      const makes = uniqueSorted(
        applications.filter((item) => itemMatchesYear(item, year)).map((item) => item.make)
      );
      fillSelect(makeSelect, makes, makeSelect.dataset.placeholder || 'Make');
      makeSelect.disabled = !year || makes.length === 0;

      const models = uniqueSorted(
        filtered()
          .filter((item) => !make || item.make === make)
          .map((item) => item.model)
      );
      fillSelect(modelSelect, models, modelSelect.dataset.placeholder || 'Model / Generation');
      modelSelect.disabled = !year || !make || models.length === 0;
      submit.disabled = applications.length === 0;
      showError('');
    };

    yearSelect.addEventListener('change', () => {
      makeSelect.value = '';
      modelSelect.value = '';
      refresh();
    });

    makeSelect.addEventListener('change', () => {
      modelSelect.value = '';
      refresh();
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      showError('');

      const year = yearSelect.value;
      const make = makeSelect.value;
      const model = modelSelect.value;
      if (!year || !make || !model) {
        showError(form.dataset.validationMessage || 'Select year, make, and model to continue.');
        return;
      }

      const match = applications.find(
        (item) => itemMatchesYear(item, year) && item.make === make && item.model === model
      );
      if (!match || !match.url) {
        showError(form.dataset.missingMessage || 'No parts found for that vehicle yet.');
        return;
      }

      window.location.assign(match.url);
    });

    refresh();
  });
})();
